import * as React from 'react';
import { navigate } from 'libs/router';

import InputRadio from 'components/inputs/input-radio/InputRadio';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './select-ccm-campaign.scss';

applyTranslations(require('./select-ccm-campaign.i18n.json'));

import type { CcmCampaignType } from 'modules/campaigns/components/ccm/types';

type Props = {
  brandProfileId: number,
  organizationId: number
}

const SelectCcmCampaign = ({
  brandProfileId,
  organizationId
}: Props): JSX.Element => {
  const [
    typeOfCampaign,
    setTypeOfCampaign
  ] = React.useState<null | CcmCampaignType>(null);
  const [hasError, setHasError] = React.useState(false);

  return (
    <div>
      <div className="select-ccm-campaign">
        <div className="select-ccm-campaign__subtitle">
          {__t('select_ccm_campaign.subtitle')}
        </div>
        <div className="select-ccm-campaign__cards">
          <div className="select-ccm-campaign__card">
            <InputRadio
              label=""
              id="type-of-campaign"
              name="type-of-campaign-ccm-creatorless"
              value="ccm_creatorless"
              checked={typeOfCampaign === 'creatorless'}
              onChange={() => setTypeOfCampaign('creatorless')}
            />
            <div className="select-ccm-campaign__card--title">
              <strong>{__t('select_ccm_campaign.brand_outfit.pre_title')}</strong>
              {__t('select_ccm_campaign.brand_outfit.title')}
            </div>
            <div className="select-ccm-campaign__card--subtitle">
              {__t('select_ccm_campaign.brand_outfit.subtitle')}
            </div>
            <div className="select-ccm-campaign__card--image_title">
              {__t('select_ccm_campaign.brand_image_title')}
            </div>
            <div className="lazyload select-ccm-campaign__card--image select-ccm-campaign__card--image--brand" />
          </div>
          <div className="select-ccm-campaign__card">
            <InputRadio
              label=""
              id="type-of-campaign-ccm"
              name="type-of-campaign"
              value="ccm"
              checked={typeOfCampaign === 'creatorfull'}
              onChange={() => {
                setHasError(false);
                setTypeOfCampaign('creatorfull');
              }}
            />
            <div className="select-ccm-campaign__card--title">
              <strong>{__t('select_ccm_campaign.creator_outfit.pre_title')}</strong>
              {__t('select_ccm_campaign.creator_outfit.title')}
            </div>
            <div className="select-ccm-campaign__card--subtitle">
              {__t('select_ccm_campaign.creator_outfit.subtitle')}
            </div>
            <div className="select-ccm-campaign__card--image_title">
              {__t('select_ccm_campaign.creator_image_title')}
            </div>
            <div className="lazyload select-ccm-campaign__card--image select-ccm-campaign__card--image--creator" />
          </div>
        </div>
        {
          hasError && (
            <div className="select-ccm-campaign__error">
              {__t('validators.required_field')}
            </div>
          )
        }
      </div>
      <div className="select-ccm-campaign__actions">
        <ActionButton
          color="tertiary"
          onClick={() => {
            navigate.to(`/organizations/${organizationId}/campaigns`);
          }}
        >
          {__t('select_ccm_campaign.buttons.cancel')}
        </ActionButton>
        <ActionButton
          color="primary"
          onClick={() => {
            if (typeOfCampaign && brandProfileId) {
              navigate.to(`/brand/profiles/${brandProfileId}/campaigns/ccm/create?campaign_type=${typeOfCampaign}`);
            } else {
              setHasError(true);
            }
          }}
        >
          {__t('select_ccm_campaign.buttons.next')}
        </ActionButton>
      </div>
    </div>

  );
};

export default SelectCcmCampaign;
